let lenis = null;

export const setLenis = (l) => {
  lenis = l;
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const PHONE = "(613) 621-5537";
export const PHONE_HREF = "tel:+16136215537";
export const JOBBER_CLIENT_HUB_URL = "";
